import {Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_gori/helpers'
import {useIntl} from 'react-intl'
import {ROUTES} from '../../../../_gori/constants'

export function WhatIsShipbae() {
  const intl = useIntl()

  return (
    <section className='what-is-shipbae bg-white overflow-x-hidden'>
      <div className='container d-flex flex-column align-items-center' style={{maxWidth: '1027px'}}>
        <h2 className='h2 text-left mb-8 text-center'>
          {intl.formatMessage({id: 'WHAT_IS'})}
          <img
            className='d-inline mx-3'
            src={toAbsoluteUrl('/media/gori/integrations/shipbae-logo.svg')}
            alt='Shipbae'
          />
          ?
        </h2>
        <div className='d-flex flex-column align-items-center gap-10'>
          <p className='text-center mb-0'>{intl.formatMessage({id: 'WHAT_IS_DESC'})}</p>
          <Link
            to={ROUTES.AUTH.REGISTRATION}
            className='btn btn-outline btn-color btn-primary-deep hover-orange rounded-pill text-center d-block w-fit-content mx-auto px-9 py-6'
          >
            <img
              className='me-3'
              src={toAbsoluteUrl('/media/gori/landing/store.svg')}
              alt='store-icon'
            />
            {intl.formatMessage({id: 'LANDING_BUTTON_START_FREE'})}
          </Link>
        </div>
      </div>
    </section>
  )
}
